import React, { useCallback, FC } from 'react';
import { useParams } from 'react-router-dom';

import { Nullable } from 'src/types/nullable.type';
import useOnboardingAssistant from '../hooks/onboarding-assistant.hook';
import { PageOnboardingOrganization, PageUserAvatar, PageOnboardingStory, PageOrganizationBrand, PageOnboardingPersona } from '.';
import { PageOnboardingPurpose } from './onboarding-purpose.page';
import { PageOnboardingCreateJourney } from './create-journey.page';
import OnboardingContentWrapper from '../components/layout/onboarding-content-wrapper';

const onboardingStepAssistantTextMap: Record<string, Nullable<string>> = {
  organization: 'Your organization',
  brand: 'Your brand',
  avatar: 'Your avatar',
  persona: 'Your role?',
  story: 'Your story',
  helpful: 'Where can Journey be most helpful?',
  'create-journey': 'Create your first journey'
};

export const PageOnboarding: FC = () => {
  const { step } = useParams();
  useOnboardingAssistant(onboardingStepAssistantTextMap[step || 'persona']);

  const renderOnboardingComponent = useCallback(() => {
    console.log("step here",step)
    switch (step) {
      case 'organization':
        return <PageOnboardingOrganization />;
      case 'brand':
        return <PageOrganizationBrand />;
      case 'avatar':
        return <PageUserAvatar />;
      case 'persona':
        return <PageOnboardingPersona />;
      case 'story':
        return <PageOnboardingStory />;
      case 'purpose':
        return <PageOnboardingPurpose />;
      case 'create-journey-step':
        return <PageOnboardingCreateJourney />;
      default:
        return <PageOnboardingPersona />;
    }
  }, [step]);

  return (
    <div className='flex flex-col items-center justify-center w-full'>
      <div className='w-full  mx-auto px-4'>
        <OnboardingContentWrapper className='transition-all duration-500 ease-in-out transform hover:shadow-xl'>
          <div className='mt-6 space-y-6'>{renderOnboardingComponent()}</div>
        </OnboardingContentWrapper>
      </div>
    </div>
  );
}; 